import { gatewayFetch } from "./rate-limit";

export async function getIndexSize() {
  const response = await gatewayFetch("/api/gateway/index-size", { cache: "default" });
  if (!response.ok) throw new Error(`Failed to load index size: ${response.status}`);
  return (await response.json()).found;
}

export async function getCaseByStandardCaseNumber(standardCaseNumber, token) {
  const caseNumber = String(standardCaseNumber || "").trim();

  if (!caseNumber) {
    return null;
  }

  const response = await gatewayFetch(
    `/api/gateway/summaries/${encodeURIComponent(caseNumber)}`,
    {
      headers: token ? { Authorization: `Bearer ${token}` } : {},
      cache: "no-store",
    }
  );
  if (response.status === 404) return null;
  if (!response.ok) throw new Error(`Failed to load summary: ${response.status}`);
  return response.json();
}
